module.exports = __webpack_public_path__ + "static/media/creative-developer2.b5cd51af.png";